/**
 * MVC Uygulama Cookie İsimleri
 * MVC uygulaması ile paylaşılan cookie'lerin isimleri
 */

export const MVC_SESSION_COOKIE_NAMES = {
  TL5009: process.env.NEXT_PUBLIC_MVC_TL5009_COOKIE_NAME || "TL5009", // User session ID
  TS5009: process.env.NEXT_PUBLIC_MVC_TS5009_COOKIE_NAME || "TS5009", // Session token
  TIT5009: process.env.NEXT_PUBLIC_MVC_TIT5009_COOKIE_NAME || "TIT5009", // Session info
};

export const SAKA_COOKIE_NAMES = {
  AFFILIATE_ID: "AffiliateId",
  DEVICE_ID: "device-id",
  SESSION_TOKEN: "session-token",
  SESSION_ID: "session-id",
  LOCALE: "saka-locale",
  CURRENCY: "saka-currency",
  SESSION: "saka-session",
  CONSENT: "saka-cookie-consent",
  GUEST_USER: "saka-cookie-guest-user",
};
